import React from 'react';
import { AlertCircle } from 'lucide-react';

import { Alert, AlertDescription } from './ui/alert';
import { cn } from '../lib/utils';

interface FormErrorProps {
  /** Copy from humanizeError(err, "Couldn't …"); null renders nothing. */
  message: string | null;
  className?: string;
}

/**
 * The submit-failure slot of a dialog or form that stays open.
 *
 * Place it directly above DialogActions / DialogFooter or a save bar, outside
 * any scroll pane, so the message is in view next to the button that caused
 * it. It never moves focus and never scrolls: the destructive Alert's
 * role="alert" announces it. A refusal about one field goes under that field
 * instead (classifyError(err).field), and a load failure is an ErrorState.
 */
export const FormError: React.FC<FormErrorProps> = ({ message, className }) => {
  if (!message) return null;
  return (
    <Alert variant="destructive" className={cn('shrink-0', className)}>
      <AlertCircle aria-hidden="true" />
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  );
};
